
import {useSelector} from "react-redux";

import $ from 'jquery';
import { useEffect, useState } from "react";
window.jQuery = $;
require('signalr');

const IndicatorsWebView = (props) => {
	
	
	const {DataCompany, ...auth} = useSelector(state => state.auth);
	const [option, setOption] = useState('')
	
	console.log(auth)

	useEffect(() => {

		const path = props.location.pathname.split("/")[1];
		setOption('');
		console.log(path)
		if (!path) {
			return;
		}
		setOption(path === 'gastos' 
					? 'ChartGastoGraph'
					: path === 'gastos-pc'
						? 'ChartGraphControl'
						: 'ChartGraphControlGeneral'
		)
	}, [props.location.pathname])

	if (!DataCompany?.Token) {
		return <></>;
	}

	console.log(`${process.env.REACT_APP_IFRAME_URL}/General/${option}?key=60|593&moduleIdParam=${process.env.REACT_APP_MODULE_ID}&tokenParam=${DataCompany.Token}&moduleIdExternalParam=30`)
	return (
		<>
		{option !== '' && 
		
		// <iframe 
		// 	style={{      
		// 		display: "block",  /* iframes are inline by default */   
		// 		height: "95%",  /* Set height to 100% of the viewport height */   
		// 		width: "100%",  /* Set width to 100% of the viewport width */     
		// 		border: "none", /* Remove default border */
		// 		background: "white", /* Just for styling */
		// 	}}
		// 	title="unique"
		// 	src={`${process.env.REACT_APP_IFRAME_URL}/General/${option}?key=60|593&securityContent=1&moduleIdParam=30&tokenParam=${'EAAAADUO3QQwJJQFZVcUZS5rrUhGe6ENXaqQK9/3JTReHtiDwHjlg5vLwJi/H7GAeqhdHg=='}`}
		// />
		<iframe 
			title="unique"
			src={`${process.env.REACT_APP_IFRAME_URL}/General/${option}?key=60|593&moduleIdParam=${process.env.REACT_APP_MODULE_ID}&tokenParam=${DataCompany.Token}&moduleIdExternalParam=30`}
        	style={{
				top: 0,
				left: 0,
				width: "100%",
				height: "100%",
				position: "border: none"
			}}        
        >
		</iframe>
		
		}
		</>
	);
};

export default IndicatorsWebView;
